module.exports = __webpack_public_path__ + "static/media/netagencias.1e516862.png";